import script from "./LCDReadOnly.vue?vue&type=script&setup=true&lang=ts"
export * from "./LCDReadOnly.vue?vue&type=script&setup=true&lang=ts"

import "./LCDReadOnly.vue?vue&type=style&index=0&id=d45be6c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d45be6c6"]])

export default __exports__